import { render, staticRenderFns } from "./KitchenSchedule.vue?vue&type=template&id=499608b5&"
import script from "./KitchenSchedule.vue?vue&type=script&lang=js&"
export * from "./KitchenSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports